import { render, staticRenderFns } from "./swiperBannerPhone.vue?vue&type=template&id=1d80ec49&"
import script from "./swiperBannerPhone.vue?vue&type=script&lang=js&"
export * from "./swiperBannerPhone.vue?vue&type=script&lang=js&"
import style0 from "./swiperBannerPhone.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports